"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tethys = void 0;
exports.tethys = {
    router: '0x81b9FA50D5f5155Ee17817C21702C3AE4780AD09',
    masterchef: '0x54A8fB8c634dED694D270b78Cb931cA6bF241E21',
};
